import { createSlice } from "@reduxjs/toolkit";

const LOCAL_STORAGE_KEY = "calculatorState";

// Load from localStorage
const loadFromLocalStorage = () => {
  try {
    const savedState = localStorage.getItem(LOCAL_STORAGE_KEY);

    return savedState ? JSON.parse(savedState) : null;
  } catch {
    return null;
  }
};

// Default state — always reset isCalculatorScreen to false on load (never auto-reopen)
const savedState = loadFromLocalStorage();

const initialState = savedState
  ? { ...savedState, isCalculatorScreen: false }
  : {
      isCalculatorScreen: false,
      unitId: null,
      engrainId: null,
      floorPlanData: null,
      feeDisclaimer: null,
    };

// Save to localStorage
const saveToLocalStorage = (state) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
};

// Slice
export const calculatorSlice = createSlice({
  name: "calculator",
  initialState,
  reducers: {
    setIsCalculatorScreen: (state, action) => {
      state.isCalculatorScreen = action.payload;
      saveToLocalStorage(state);
    },
    setUnitId: (state, action) => {
      state.unitId = action.payload;
      saveToLocalStorage(state);
    },
    setEngrainId: (state, action) => {
      state.engrainId = action.payload;
      saveToLocalStorage(state);
    },
    setFloorPlanData: (state, action) => {
      state.floorPlanData = action.payload;
      saveToLocalStorage(state);
    },
    setFeeDisclaimer: (state, action) => {
      state.feeDisclaimer = action.payload;
      saveToLocalStorage(state);
    },
    resetCalculatorState: (state) => {
      state.isCalculatorScreen = false;
      state.unitId = null;
      state.engrainId = null;
      state.floorPlanData = null;
      state.feeDisclaimer = null;
      saveToLocalStorage(state);
    },
  },
});

// Selectors
export const selectIsCalculatorScreen = (state) => state.calculator.isCalculatorScreen;
export const selectUnitId = (state) => state.calculator.unitId;
export const selectEngrainId = (state) => state.calculator.engrainId;
export const selectFloorPlanData = (state) => state.calculator.floorPlanData;
export const selectFeeDisclaimer = (state) => state.calculator.feeDisclaimer;

// Actions
export const { setIsCalculatorScreen, setUnitId, setEngrainId, setFloorPlanData, setFeeDisclaimer, resetCalculatorState } = calculatorSlice.actions;

export default calculatorSlice.reducer;
